export interface VarnishLogoProps {
    width?: string | number;
    height?: string | number;
}

/**
 * Component that renders the text portion of the Varnish2 Logo.
 */
export function VarnishLogo(props: VarnishLogoProps) {
    return (
        <svg width={props.width} height={props.height} xmlns="http://www.w3.org/2000/svg">
            <g>
                <rect
                    x="-1"
                    y="-1"
                    width="13.3332"
                    height="11.33323"
                    id="canvas_background"
                    fill="none"
                />
            </g>
            <g>
                <path
                    d="m24.5,56c13.531,0 24.5,-10.9691 24.5,-24.5c0,-13.531 -10.969,-24.50003 -24.5,-24.50003s-24.5,10.96903 -24.5,24.50003c0,13.5309 10.969,24.5 24.5,24.5z"
                    fill="#08426c"
                    id="svg_1"
                />
                <path
                    d="m43.2,14l-26.2,26.3l10.1999,0l26.2,-26.3l-10.1999,0z"
                    fill="#ffc903"
                    id="svg_2"
                />
                <path
                    d="m51.2,14l-26.2,26.3l10.2,0l26.2,-26.3l-10.2,0z"
                    fill="#00bdff"
                    id="svg_3"
                />
                <path d="m67.5,14l-8.3,0l-26.2,26.3l8.3,0l26.2,-26.3z" fill="#008ee6" id="svg_4" />
                <path
                    d="m20.6,35.5999l-11.70002,0c-0.2,0 -0.4,-0.1 -0.6,-0.3l-2.9,-4.5c-0.7,-1.1 -0.7,-2.4 -0.1,-3.5s1.7,-1.8 3,-1.8l11.20002,0c0.4,0 0.6,-0.3 0.7,-0.4s0.2,-0.4 0,-0.8l-3,-5.2c-0.2,-0.3 -0.1,-0.7 0.3,-0.9c0.3,-0.2 0.7,-0.1 0.9,0.3l3,5.2c0.4,0.7 0.4,1.5 0,2.2s-1.1,1.1 -1.9,1.1l-11.20002,0c-0.8,0 -1.4,0.4 -1.8,1.1s-0.3,1.5 0.1,2.1l2.7,4.2l11.30002,0c0.4,0 0.7,0.3 0.7,0.7c0,0.2 -0.3,0.5 -0.7,0.5z"
                    fill="#fff"
                    id="svg_5"
                />
                <path
                    d="m21.5001,16.6157l-8.9,-14.6c-1.1,-2 -3.60004,-2.59999 -5.50004,-1.39999c-1.9,1.09999 -2.5,3.59999 -1.4,5.49999l8.90004,14.6c1.2,1.9 3.6,2.5 5.5,1.4s2.6,-3.6 1.4,-5.5z"
                    fill="#666d74"
                    id="svg_6"
                />
                <path
                    d="m9.19995,8c2.20915,0 4.00005,-1.79086 4.00005,-4s-1.7909,-4 -4.00005,-4c-2.20914,0 -4,1.79086 -4,4s1.79086,4 4,4z"
                    fill="#4c5258"
                    id="svg_7"
                />
                <path
                    d="m11.8,31c-3.30001,0 -6.00001,2.7 -6.00001,6s2.7,6 6.00001,6l8,0l0,-12l-8,0z"
                    fill="#ffc903"
                    id="svg_8"
                />
                <path
                    d="m19.8,31c-3.3,0 -6,2.7 -6,6s2.7,6 6,6l8.3,0l0,-12l-8.3,0z"
                    fill="#00bdff"
                    id="svg_9"
                />
                <path
                    d="m28.1,31c-3.3,0 -6,2.7 -6,6s2.7,6 6,6l8.1,0l0,-12l-8.1,0z"
                    fill="#008ee6"
                    id="svg_10"
                />
                <path
                    d="m36.2,43c3.3137,0 6,-2.6863 6,-6s-2.6863,-6 -6,-6s-6,2.6863 -6,6s2.6863,6 6,6z"
                    fill="#fff"
                    id="svg_11"
                />
                <path
                    d="m36.2,38.9c1.0493,0 1.9,-0.8507 1.9,-1.9c0,-1.0494 -0.8507,-1.9 -1.9,-1.9c-1.0494,0 -1.9,0.8506 -1.9,1.9c0,1.0493 0.8506,1.9 1.9,1.9z"
                    fill="#333"
                    id="svg_12"
                />
                <g fill="#666d74" id="svg_13" />
            </g>
        </svg>
    );
}
